export const FEATURE_TAGS = "tags";
export const FEATURE_DEV = "dev";
export const FEATURE_SECURE_MEDIA = "secure_media";
export const FEATURE_OPTIMIZED_API = "optimized_api";
export const FEATURE_FOLLOW = "follow";
export const FEATURE_TASKS = "tasks";
export const FEATURE_WITNESS = "witness";
export const FEATURE_DRAFTJS = "draft_editor";
export const FEATURE_WORKSPACE_ROLES = "workspace_roles";
